import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementOptionsSidebar from "../components/tour/TourManagementSidebarOptionsSidebar";
import TourManagementAvailabilityHeader from "../components/TourManagementAvailabilityHeader";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { usePackage } from "../hooks/usePackage";
import { RootState } from "../app/store";
import {
  setFeeValue,
  setOptionsData,
  setPackageData,
  setPackageGallery,
} from "../reducer/tourReducer";
import {
  CreatePackageOptionsProps,
  CreatePackageProps,
} from "../declarations/tourServices";
import { toast } from "react-toastify";
import { Category } from "@mui/icons-material";
import { Addon } from "../types/data";
import { useOptions } from "../hooks/useOptions";
import { resetOptionEdit } from "../reducer/tourEditReducer";

type Tier = {
  quantityFrom: number;
  quantityTo: number;
  customerPays: string;
  commission: string;
  payout: string;
};

// todo: i cant create create options with preoptionid and if i try to add customer pays before the to value it creates an error
function TourManagementPackageAvailabilityAddOnPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { createPreOptions } = useOptions();
  const [loading, setLoading] = useState(false);
  const progressref = useRef(20);
  const { PrepackageDataId, optionsData, packageId } = useSelector(
    (state: RootState) => state.tour
  );
  const {
    tourEdit,
    optionId,
    id: editPackageId,
  } = useSelector((state: RootState) => state.edit);
  const { packageData, gallery, feeValue } = useSelector(
    (state: RootState) => ({
      packageData: state.tour.packageData,
      gallery: state.tour.gallery as string[], // Ensure gallery is typed as an array of strings
      feeValue: state.tour.feeValue,
    })
  );
  const { getPlatformFee } = usePackage();
  const { calculateNetProfit } = usePackage();
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    if (location.state && location.state.optionData) {
      dispatch(setOptionsData(location.state.optionData));
    }
  }, [location.state, dispatch]);

  // State for addons
  // const [addons, setAddons] = useState<Addon[]>([
  //   {
  //     keyword: "Additional Hour",
  //     tiers: [
  //       {
  //         quantityFrom: "1", // Fixed value
  //         quantityTo: "",
  //         customerPays: "",
  //         commission: "30%", // Default value
  //         payout: "",
  //       },
  //     ],
  //   },
  // ]);
  const [addOns, setAddOns] = useState<Addon[]>(optionsData?.addOns || []);

  const [tiers, setTiers] = useState([]);

  useOnLoadPage({ tabActive: "create" });

  // useEffect(() => {
  //   const handleKeyDown = (event: any) => {
  //     if (event.keyCode === 13) {
  //       handleAdd();
  //     }
  //   };

  //   document.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [keyword]);

  useEffect(() => {
    const fetchPlatformFee = async () => {
      try {
        setLoading(true);
        const response = await getPlatformFee({ setLoading });
        setLoading(false);
        dispatch(setFeeValue(response.value));
      } catch (error) {
        console.error("Failed to fetch platform fee:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlatformFee();
  }, []);

  console.log("feevalue", feeValue);

  const weeklyScheduleObject = packageData.weekSchedule?.reduce(
    (acc: any, day: any) => {
      acc[day.value] =
        day.start && day.end ? `${day.start} - ${day.end}` : "Closed";
      return acc;
    },
    {}
  );

  const operatingHourSting = packageData?.exceptionDates
    ?.map((item: any) => {
      const startEnd =
        item.start && item.end ? `${item.start} - ${item.end}` : "No hours set";
      return `${item.date}: ${startEnd}`;
    })
    .join(", ");

  const handleAddAddon = () => {
    if (!keyword.trim()) return;

    const newAddon: Addon = {
      keyword,
      tiers: [
        {
          quantityFrom: "1",
          quantityTo: "",
          customerPays: "",
          commission: "30%",
          payout: 0,
        },
      ],
    };

    setAddOns((prev: any) => {
      const updatedAddOns = [...prev, newAddon];
      dispatch(setOptionsData({ ...optionsData, addOns: updatedAddOns }));
      return updatedAddOns;
    });

    setKeyword("");
  };

  const handleRemoveAddon = (index: number) => {
    setAddOns((prev) => {
      const updatedAddOns = prev?.filter((_, i) => i !== index);
      dispatch(setOptionsData({ ...optionsData, addOns: updatedAddOns }));
      return updatedAddOns;
    });
  };

  const handleAddTier = (addonIndex: number) => {
    setAddOns((prev: any) => {
      const updatedAddOns = prev.map((addon: any, index: any) => {
        if (index === addonIndex) {
          return {
            ...addon,
            tiers: [
              ...addon.tiers,
              {
                quantityFrom: "1",
                quantityTo: "",
                customerPays: "",
                commission: "30%",
                payout: "",
              },
            ],
          };
        }
        return addon;
      });
      dispatch(setOptionsData({ ...optionsData, addOns: updatedAddOns }));
      return updatedAddOns;
    });
  };

  const handleRemoveTier = (addonIndex: number, tierIndex: number) => {
    setAddOns((prev) => {
      const updatedAddOns = prev.map((addon, aIndex) => {
        if (aIndex === addonIndex) {
          return {
            ...addon,
            tiers: addon.tiers.filter((_, tIndex) => tIndex !== tierIndex),
          };
        }
        return addon;
      });

      dispatch(setOptionsData({ ...optionsData, addOns: updatedAddOns }));

      return updatedAddOns;
    });
  };

  console.log("packagedatagrouppricing", packageData.groupPricing);

  const handleTierChange = (
    addonIndex: number,
    tierIndex: number,
    field: keyof Tier,
    value: string | number
  ) => {
    // Parse the incoming value to a number where needed
    const parsedValue =
      field === "customerPays" || field === "payout"
        ? Number(value) || 0 // Ensure it defaults to 0 if not a valid number
        : Number(value) || "";

    // Only calculate the price and net profit for specific fields
    const price = field === "customerPays" ? Math.abs(Number(value)) || 0 : 0;

    // Safely calculate net profit
    const netPrice = calculateNetProfit(price) || 0; // Ensure fallback to 0 if NaN

    // Update addons state
    setAddOns((prev: any) => {
      const updatedAddOns = prev.map((addon: any, aIndex: any) => {
        if (aIndex === addonIndex) {
          return {
            ...addon,
            tiers: addon.tiers.map((tier: any, tIndex: any) => {
              if (tIndex === tierIndex) {
                return {
                  ...tier,
                  [field]: parsedValue, // Update the field
                  ...(field === "customerPays" && { payout: netPrice }), // Update payout
                };
              }
              return tier;
            }),
          };
        }
        return addon;
      });

      // Dispatch updated addOns to Redux
      dispatch(setOptionsData({ ...optionsData, addOns: updatedAddOns }));
      return updatedAddOns;
    });
  };

  console.log("optionsData in add on page", optionsData);
  console.log("pricing option selected", optionsData.pricingOption);
  console.log("groupPricing:", optionsData.groupPricing);

  let pricingPayload = {};

  if (optionsData.pricingOption === "fixed") {
    pricingPayload = {
      pricePerIndividual: [
        {
          calculatedPrice: optionsData.samePricing?.calculatedPrice,
          value: optionsData.samePricing?.singlePrice,
          description: "Standard pricing for individual entry",
        },
      ],
    };
  } else if (
    optionsData.pricingOption === "vehicle" &&
    Array.isArray(optionsData.groupPricing)
  ) {
    pricingPayload = {
      pricePerVehicle: optionsData.groupPricing.map((group) => ({
        name: group.name,
        from: group.from,
        to: group.to,
        price: group.price,
      })),
    };
  } else if (
    optionsData.pricingOption === "age_group" &&
    Array.isArray(optionsData.pricing)
  ) {
    pricingPayload = {
      pricingCategories: optionsData.pricing.map((item) => ({
        ageGroup: item.category,
        ageRange: `${item.minAge} - ${item.maxAge}`,
        permitted: item.categoryPermitted,
        freeOfChange: item.categoryFree,
        adultRequired: item.adultRequired || null,
      })),
      pricePerAgeGroup: optionsData.pricing.map((item) => ({
        ageGroup: item.category,
        value: item.singlePrice,
        calculatedPrice: item.calculatedPrice,
      })),
    };
  }

  const onContinue = async () => {
    const optionsPayload = {
      _id: optionsData._id,
      title: optionsData.title,
      package: optionsData.package,
      referenceCode: optionsData.referenceCode,
      description: optionsData.description,
      maxGroupSize: optionsData.maxGroupSize,
      guideMaterial: optionsData.guideMaterial,
      customerSkipLine: optionsData.customerSkipLine,
      lineToSkip: optionsData.lineToSkip,
      wheelchair: optionsData.wheelchair,
      accessTime: optionsData.accessTime,
      cutOffTime: optionsData.cutOffTime,
      meetingAddress: optionsData.meetingPoint?.address,
      meetingSetting: optionsData.meetingSetting,
      meetingPointDescription: optionsData.meetingPointDescription,
      reservations: optionsData.reservations,
      reservationSystem: optionsData.reservationSystem,
      availability: optionsData.availability,
      cancelationPolicy: {
        type: optionsData.cancelationPolicy?.type,
        description: optionsData.cancelationPolicy?.description,
        cancelIfBadWeather: optionsData.cancelationPolicy?.cancelIfBadWeather,
        cancelIfInsufficientTravelers:
          optionsData.cancelationPolicy?.cancelIfInsufficientTravelers,
        refundEligibility: optionsData.cancelationPolicy?.refundEligibility,
      },
      pricingOption: optionsData.pricingOption,
      ...pricingPayload,
      addOns: optionsData.addOns,
    };

    const updatedPackageData2 = {
      ...optionsPayload,
      ...optionsData,
    };

    console.log("optionsPayload before being sent", optionsPayload);

    try {
      setLoading(true);
      if (tourEdit) {
        dispatch(resetOptionEdit());
        dispatch(setOptionsData(updatedPackageData2));
        const pkgId = packageData._id;
        navigate(`/manage/product/${pkgId}/${optionId}`, {
          state: {
            fromEdit: true,
            option: updatedPackageData2,
            packageId: pkgId,
          },
        });
        return;
      } else {
        const response = await createPreOptions(optionsPayload);
        if (response?.status === 201) {
          navigate(Paths.tourManagementPackageOptions);
        }
      }
      setLoading(false);
    } catch (error) {
      console.error("Error in onContinue:", error);
      toast.error("An error occurred while creating the options.");
    }
  };

  const onSave = () => {
    navigate(-1);
  };

  console.log("packagedata addons", optionsData.addOns);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementOptionsSidebar selected={6} />
        <div className={Classname.detail}>
          <TourManagementAvailabilityHeader active={5} />
          <div className={Classname.title}>
            Add-ons <span className={Classname.titleOptional}>(optional)</span>{" "}
          </div>
          <div className={Classname.title}>What’s an add-on?</div>
          <div>
            Sell additional services or items for your activities to enhance
            travellers’ experience.
          </div>
          <div>
            {/* Keyword Input */}
            <div className="flex items-center gap-4">
              <input
                type="text"
                placeholder="Enter addon keyword"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                className="border rounded-lg p-2 w-full my-5"
              />
              <button
                className="bg-primary h-10 px-4 rounded-lg text-white text-sm w-24"
                onClick={handleAddAddon}
              >
                + Add
              </button>
            </div>

            {(optionsData.addOns || []).map((addon, addonIndex) => (
              <div key={addonIndex} className="mt-4">
                <div className="flex justify-between items-center my-3">
                  <span className="text-lg lg:text-xl font-bold">
                    {addon.keyword}
                  </span>

                  <button
                    className="text-red-500"
                    onClick={() => handleRemoveAddon(addonIndex)}
                  >
                    Remove Addon
                  </button>
                </div>

                <div className="hidden lg:flex gap-16 ml-10 flex-wrap">
                  <span>Quantity</span>
                  <span>Customer Pays</span>
                  <span>Commission</span>
                  <span>Payout</span>
                </div>

                {(addon.tiers || []).map((tier, tierIndex) => (
                  <div>
                    <div
                      key={tierIndex}
                      className="flex flex-col lg:flex-row items-center gap-4 my-2 w-full max-w-2xl"
                    >
                      <div className="flex gap-2 lg:gap-4 w-full">
                        <div>
                          <div className="lg:hidden mb-2">Quantity</div>
                          <div className="flex items-center gap-2">
                            <input
                              type="number"
                              placeholder="From"
                              readOnly
                              value={tier.quantityFrom}
                              onChange={(e) =>
                                handleTierChange(
                                  addonIndex,
                                  tierIndex,
                                  "quantityFrom",
                                  e.target.value
                                )
                              }
                              className="border-none rounded-lg p-2 w-8 lg:w-12 "
                            />
                            <span>To</span>
                            <input
                              type="number"
                              placeholder="To"
                              value={tier.quantityTo}
                              onChange={(e) =>
                                handleTierChange(
                                  addonIndex,
                                  tierIndex,
                                  "quantityTo",
                                  e.target.value
                                )
                              }
                              className="border rounded-lg p-2 w-16"
                            />
                          </div>
                        </div>
                        <div>
                          <div className="lg:hidden mb-2">Customer Pays</div>
                          <input
                            type="text"
                            placeholder="USD"
                            value={tier.customerPays}
                            onChange={(e) =>
                              handleTierChange(
                                addonIndex,
                                tierIndex,
                                "customerPays",
                                e.target.value
                              )
                            }
                            className="border rounded-lg p-2 w-32"
                          />
                        </div>
                      </div>
                      <div className="flex gap-2 lg:gap-4 w-full">
                        <div>
                          <div className="lg:hidden mb-2">Commission</div>
                          <input
                            type="text"
                            value={`${feeValue as number} %`}
                            readOnly
                            className="border rounded-lg p-2 w-32 bg-gray-100"
                          />
                        </div>
                        <div>
                          <div className="lg:hidden mb-2">Payout</div>
                          <input
                            type="text"
                            placeholder="Payout"
                            readOnly
                            value={tier.payout as any}
                            onChange={(e) =>
                              handleTierChange(
                                addonIndex,
                                tierIndex,
                                "payout",
                                e.target.value
                              )
                            }
                            className="border rounded-lg p-2 w-32 bg-gray-100"
                          />
                        </div>
                      </div>
                      <button
                        onClick={() => handleRemoveTier(addonIndex, tierIndex)}
                        className="text-red-500 text-sm flex-shrink-0"
                      >
                        Remove Tier
                      </button>
                    </div>
                  </div>
                ))}

                <button
                  onClick={() => handleAddTier(addonIndex)}
                  className="text-primary mt-2"
                >
                  + Add Tier
                </button>
              </div>
            ))}
          </div>

          <div className={Classname.buttonsContainer}>
            <button className={Classname.saveButton} onClick={handleBack}>
              Back
            </button>
            <button className={Classname.continueButton} onClick={onContinue}>
              {loading ? "Please Wait..." : "Save and continue"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageAvailabilityAddOnPage;

const Classname = {
  gridContainer: "grid grid-cols-4 gap-4",
  gridItem: "flex text-sm items-center h-8 gap-2 p-4",
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  titleOptional: "text-sm text-gray-500 font-normal",
  input: "flex flex-1 h-12 border border-gray-300 rounded-md px-4 mt-2",
  inputSmall: "flex w-10 h-8 border bg-gray-200 rounded-md px-2 mt-2",
  inputPrice: "flex w-24 h-8 border bg-gray-200 rounded-md px-2 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6",
  description: "flex text-base mb-4",
  buttonsContainer: "flex flex-1 justify-between lg:justify-end gap-3 mt-10",
  highlightButton:
    "font-bold flex items-center gap-2 mt-10 cursor-pointer text-primary1 py-4",
  saveButton:
    "h-12 px-6 flex items-center justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
  suggestionContainer: "flex flex-wrap gap-4 mt-4",
  suggestion:
    "text-primary1 text-sm border border-primary1 px-3 py-1 rounded-md",
  keyword:
    "text-primary1 text-sm border border-primary1 px-3 py-1 rounded-md cursor-pointer flex items-center gap-2",
};
